import { render } from "./HrCaseManagement.vue?vue&type=template&id=a7a0f3d4&scoped=true"
import script from "./HrCaseManagement.vue?vue&type=script&lang=js"
export * from "./HrCaseManagement.vue?vue&type=script&lang=js"

import "./HrCaseManagement.vue?vue&type=style&index=0&id=a7a0f3d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a0f3d4"]])

export default __exports__